import { Enum } from "@/commons/enums/Type";

export class ReportTypeEnum {
  static PREBID_ANALYTICS = { value: 1, text: "Prebid Analytics" };
  static BI_REPORT = { value: 2, text: "BI Report" };
  static GOOGLE_AD_MANAGER = { value: 3, text: "Google Ad Manager" };

  static getByValue(value: number): Enum | undefined {
    if (value === ReportTypeEnum.PREBID_ANALYTICS.value) {
      return ReportTypeEnum.PREBID_ANALYTICS;
    }
    if (value === ReportTypeEnum.BI_REPORT.value) {
      return ReportTypeEnum.BI_REPORT;
    }
    if (value === ReportTypeEnum.GOOGLE_AD_MANAGER.value) {
      return ReportTypeEnum.GOOGLE_AD_MANAGER;
    }
    return undefined;
  }

  static getEnum(): ReportTypeEnumInterface {
    return {
      PREBID_ANALYTICS: this.PREBID_ANALYTICS,
      BI_REPORT: this.BI_REPORT,
      GOOGLE_AD_MANAGER: this.GOOGLE_AD_MANAGER,
    };
  }

  static isPrebidAnalytics(value: number): boolean {
    return value === ReportTypeEnum.PREBID_ANALYTICS.value;
  }
  static isBiReport(value: number): boolean {
    return value === ReportTypeEnum.BI_REPORT.value;
  }
  static isGoogleAdManager(value: number): boolean {
    return value === ReportTypeEnum.GOOGLE_AD_MANAGER.value;
  }
}

export interface ReportTypeEnumInterface {
  PREBID_ANALYTICS: Enum;
  BI_REPORT: Enum;
  GOOGLE_AD_MANAGER: Enum;
}
